import { IconPaperclip, IconPhoto } from '@tabler/icons-react';
import { Grid, Modal, Text, TextInput } from '@mantine/core';
import React, { useState } from 'react';
import useUploadAsset from '../../../helpers/useUploadAsset';
import AssetForm from '../../Assets/AssetForm';
import AssetPickerModal from '../../Assets/AssetPickerModal';
import ErrorMessage from '../../ErrorMessage';

const FacebookAdFormImage = ({ facebookAd, setFacebookAd }) => {
  const [uploadModelOpen, setUploadModelOpen] = useState(false);
  const [selectModalOpen, setSelectModalOpen] = useState(false);

  const [asset] = useState({
    title: 'New image',
    description: 'New description',
  });
  const [userError, setUserError] = useState();

  const toggleUploadModal = () => {
    setUploadModelOpen(!uploadModelOpen);
  };
  const toggleSelectModal = () => {
    setSelectModalOpen(!selectModalOpen);
  };

  const handleImageUrlChange = (url) => {
    setFacebookAd({ ...facebookAd, imageUrl: url });
  };

  const handleImageHyperLinkChange = (url) => {
    setFacebookAd({ ...facebookAd, imageHyperLink: url });
  };

  const { uploadReferenceImage } = useUploadAsset(setUserError);

  const uploadModal = (
    <Modal opened={uploadModelOpen} onClose={() => toggleUploadModal()} title="Upload Your Custom Image *" centered>
      <AssetForm
        asset={asset}
        saveAsset={(asset, file) =>
          uploadReferenceImage(asset, file, (responseAsset) => {
            handleImageUrlChange(responseAsset);
            toggleUploadModal();
          })
        }
        closeModal={toggleUploadModal}
      />

      <div style={{ textAlign: 'right' }}>
        <ErrorMessage message={userError?.message} style={{ float: 'right' }} />
      </div>
    </Modal>
  );

  const selectModal = (
    <AssetPickerModal
      show={selectModalOpen}
      close={() => toggleSelectModal()}
      confirm={(asset, _, cb) => {
        handleImageUrlChange(asset.url);
        cb();
      }}
    />
  );

  return (
    <>
      {uploadModal}
      {selectModal}
      <Grid>
        <Grid.Col span={3}>
          <Text size="sm" fw={500}>Image URL</Text>
        </Grid.Col>
        <Grid.Col span={9} id="input-small-container">
          <IconPaperclip
            size={20}
            className={`p-10 button-element ${facebookAd.imageUrl ? 'active' : ''}`}
            style={{ float: 'left', marginRight: 4, color: 'var(--mantine-primary-color-filled)' }}
            onClick={!facebookAd.id && toggleUploadModal}
          />

          <IconPhoto
            size={20}
            className={`p-10 button-element ${facebookAd.imageUrl ? 'active' : ''}`}
            style={{ float: 'left', marginRight: 4, color: 'var(--mantine-primary-color-filled)' }}
            onClick={!facebookAd.id && toggleSelectModal}
          />

          <TextInput
            type="text"
            placeholder="Image url ..."
            value={facebookAd.imageUrl || ''}
            onChange={(e) => handleImageUrlChange(e.target.value)}
            disabled={facebookAd.id}
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={3}></Grid.Col>
        <Grid.Col span={9} p={10} pt={0} ml={4} mr={4}>
          <Text size="sm" c="dimmed">
            URL of an image to use in the ad. The image specified at the URL will be saved into the ad accounts image
            library
          </Text>
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={3}>
          <Text size="sm" fw={500}>Image Hyperlink</Text>
        </Grid.Col>
        <Grid.Col span={9} id="input-small-container">
          <TextInput
            type="text"
            placeholder="Image hyperlink..."
            value={facebookAd.imageHyperLink || ''}
            onChange={(e) => handleImageHyperLinkChange(e.target.value)}
            disabled={facebookAd.id}
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={3}></Grid.Col>
        <Grid.Col span={9} p={10} pt={0} ml={4} mr={4}>
          <Text size="sm" c="dimmed">
            Hyperlink to add to the image. When the image is clicked, the user will be redicrected to the provider url
          </Text>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default FacebookAdFormImage;
